import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Basket } from '../types/basket.type';
import { ADMIN_BASKETS_API_PATHS } from '../constants/baskets-api-paths.constants';

type UseArchiveBasketResult = {
  archiveBasket: (basketId: string) => Promise<Basket | null>;
  isSubmitting: boolean;
};

export function useArchiveBasket(): UseArchiveBasketResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveBasket = async (basketId: string): Promise<Basket | null> => {
    setIsSubmitting(true);

    try {
      const archivedBasket = await HttpClient.delete<Basket>(ADMIN_BASKETS_API_PATHS.ARCHIVE_BASKET(basketId));

      enqueueSnackbar('Panier archivé', { variant: 'success' });
      return archivedBasket;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage du panier"),
        {
          variant: 'error',
        }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveBasket, isSubmitting };
}
